// extracted by mini-css-extract-plugin
module.exports = {"main_white":"#ffffff","backDrop":"styles_backDrop__3b-a2","modal":"styles_modal__1AEYo"};